require('angular')
require('../cache/cache-module')
GoalAPIService = require('./goal-api-service')
ScoreCardAPIService = require('./score-card-api-service')
CountryAPIService = require('./country-api-service')
AppSettingAPIService = require('./app-setting-api-service')
RoundAPIService = require('./round-api-service')
PlayerAPIService = require('./player-api-service')

angular.module 'gnp-remote-api', ['gnp-cache']
  .factory 'CountryAPIService', CountryAPIService
  .factory "GoalAPIService", GoalAPIService
  .factory "ScoreCardAPIService", ScoreCardAPIService
  .factory "AppSettingAPIService", AppSettingAPIService
  .factory 'RoundAPIService', RoundAPIService
  .factory 'PlayerAPIService', PlayerAPIService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/remote-api/remote-api-module.coffee